import React from 'react';
import PropTypes from 'prop-types';

import Notes from '../components/Notes/Notes';

const NotesSummary = ({ claim, onNoteClick, noCard, hideTypeFilter, isActive = true, exposureOptionsIds }) => {
  return (
    <Notes
      claim={claim}
      onNoteClick={onNoteClick}
      noCard={noCard}
      hideTypeFilter={hideTypeFilter}
      isActive={isActive}
      exposureOptionsIds={exposureOptionsIds}
    />
  );
};

NotesSummary.propTypes = {
  claim: PropTypes.object.isRequired,
  onNoteClick: PropTypes.func.isRequired,
  hideTypeFilter: PropTypes.bool,
  noCard: PropTypes.bool,
  isActive: PropTypes.bool,
  exposureOptionsIds: PropTypes.arrayOf(PropTypes.number),
};

export default NotesSummary;
